import { Link } from "react-router-dom";
import { Logo } from "@/components/Brand";

const linkClass =
  "inline-block py-1.5 text-[15px] text-[#9FB2C9] transition-colors hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#F5A623] rounded-sm";
const headingClass =
  "font-heading text-xs font-bold uppercase tracking-[0.14em] text-[#F5A623]";

export const SiteFooter = () => (
  <footer className="border-t border-white/10 bg-[#0B132B] px-6 pt-14 pb-10" data-testid="site-footer">
    <div className="mx-auto grid max-w-[1080px] gap-10 sm:grid-cols-2 md:grid-cols-4">
      {/* Column 1: brand */}
      <div className="sm:col-span-2 md:col-span-1">
        <Logo imgClass="h-12" />
        <p className="mt-4 max-w-[320px] text-[14px] leading-relaxed text-[#8FA3BC]">
          CommandCenterADHD is a Notion based planning system for choosing what
          matters, organizing tasks around available energy, and restarting
          after interruptions.
        </p>
        <Link to="/about" className={`mt-4 inline-block font-semibold ${linkClass}`} data-testid="footer-about-link">
          About
        </Link>
      </div>

      {/* Column 2: product */}
      <div>
        <h3 className={headingClass}>Product</h3>
        <ul className="mt-4 space-y-3">
          <li><Link to="/adhd-daily-planner" className={linkClass} data-testid="footer-adhd-daily-planner-link">ADHD Daily Planner</Link></li>
          <li><Link to="/adhd-overwhelm" className={linkClass} data-testid="footer-adhd-overwhelm-link">ADHD Overwhelm</Link></li>
          <li><Link to="/adhd-planner-no-subscription" className={linkClass} data-testid="footer-adhd-no-subscription-link">Planner, No Subscription</Link></li>
          <li><Link to="/what-should-i-do-next" className={linkClass} data-testid="footer-what-to-do-next-link">What to Do Next Tool</Link></li>
          <li><Link to="/guides" className={linkClass} data-testid="footer-setup-videos-link">Setup Videos</Link></li>
          <li><a href="/#faq" className={linkClass} data-testid="footer-faq-link">FAQ</a></li>
          <li><Link to="/community" className={linkClass} data-testid="footer-community-link">Community</Link></li>
        </ul>
      </div>

      {/* Column 3: access & support */}
      <div>
        <h3 className={headingClass}>Access &amp; Support</h3>
        <ul className="mt-4 space-y-3">
          <li>
            <Link to="/about" className={linkClass} data-testid="footer-about-link">
              About
            </Link>
          </li>
          <li>
            <Link to="/recover-access" className={linkClass} data-testid="footer-recover-access-link">
              Recover Access
            </Link>
          </li>
          <li>
            <a href="mailto:support@commandcenteradhd.com" className={linkClass} data-testid="footer-contact-support-link">
              Contact Us
            </a>
          </li>
        </ul>
      </div>

      {/* Column 4: legal */}
      <div>
        <h3 className={headingClass}>Legal</h3>
        <ul className="mt-4 space-y-3">
          <li><Link to="/license" className={linkClass} data-testid="footer-license-link">License</Link></li>
          <li><Link to="/privacy" className={linkClass} data-testid="footer-privacy-link">Privacy Policy</Link></li>
          <li><Link to="/terms" className={linkClass} data-testid="footer-terms-link">Terms and Conditions</Link></li>
          <li><Link to="/refund-policy" className={linkClass} data-testid="footer-refund-link">Refund Policy</Link></li>
          <li><Link to="/cookie-policy" className={linkClass} data-testid="footer-cookie-policy-link">Cookie Policy</Link></li>
          <li><Link to="/accessibility" className={linkClass} data-testid="footer-accessibility-link">Accessibility</Link></li>
          <li>
            <button
              type="button"
              onClick={() => window.dispatchEvent(new Event("cc-open-consent"))}
              className={`${linkClass} cursor-pointer bg-transparent p-0 text-left`}
              data-testid="footer-cookie-settings-button"
            >
              Cookie Settings
            </button>
          </li>
        </ul>
      </div>
    </div>

    <div className="mx-auto mt-12 max-w-[1080px] border-t border-white/10 pt-6">
      <div>
        <p className="max-w-[820px] text-[13px] leading-relaxed text-[#94A8BE]">
          © {new Date().getFullYear()} CommandCenterADHD. This is a digital
          organizational tool. No physical product will be shipped. It is not
          medical advice or ADHD treatment. Purchases are covered by the stated 30
          day guarantee.
        </p>
        <div
          className="mt-6 flex flex-wrap items-center justify-center gap-4"
          style={{ textAlign: "center", padding: "16px 0" }}
          data-testid="footer-nxgn-badges"
        >
          <a
            href="https://www.nxgntools.com/tools/commandcenteradhd?utm_source=commandcenteradhd"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block"
            data-testid="footer-nxgn-badge"
          >
            <img
              src="https://www.nxgntools.com/api/embed/commandcenteradhd?type=LAUNCHING_SOON_ON"
              alt="Launching soon on NxGn Tools"
              loading="lazy"
              style={{ height: 48, width: "auto" }}
            />
          </a>
          <a
            href="https://www.nxgntools.com/tools/commandcenteradhd?utm_source=commandcenteradhd"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block"
            data-testid="footer-nxgn-badge-find"
          >
            <img
              src="https://www.nxgntools.com/api/embed/commandcenteradhd?type=FIND_US_ON"
              alt="Find us on NxGn Tools"
              loading="lazy"
              style={{ height: 48, width: "auto" }}
            />
          </a>
          <a
            href="https://www.nxgntools.com/tools/commandcenteradhd?utm_source=commandcenteradhd"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block"
            data-testid="footer-nxgn-badge-featured"
          >
            <img
              src="https://www.nxgntools.com/api/embed/commandcenteradhd?type=FEATURED_ON"
              alt="Featured on NxGn Tools"
              loading="lazy"
              style={{ height: 48, width: "auto" }}
            />
          </a>
        </div>
      </div>
    </div>
  </footer>
);

export default SiteFooter;
